import { createAsyncThunk } from "@reduxjs/toolkit";
import { CHAPTER, CREATE_CHAPTER_FORM } from "../@types";
import axios, { AxiosResponse } from "axios";
import apiUrl from "../constants/apiUrl";

import api from "../config/apiClient";

const baseApiUrl = `${apiUrl}/chapters/`;

export const GET_CHAPTERS = "GET_CHAPTERS";
export const getChapters = createAsyncThunk(GET_CHAPTERS, async () => {
  const res: AxiosResponse = await api.get(baseApiUrl);
  return res.data;
});

export const CREATE_CHAPTER = "CREATE_CHAPTER";
export const createChapter = createAsyncThunk(
  CREATE_CHAPTER,
  async (chapterData: CREATE_CHAPTER_FORM, { rejectWithValue }) => {
    try {
      const res: AxiosResponse = await api.post(baseApiUrl, chapterData);
      return res.data;
    } catch (err: any) {
      return rejectWithValue(err.response.data);
    }
  }
);

export const DELETE_CHAPTER = "DELETE_CHAPTER";
export const deleteChapter = createAsyncThunk<
  string | number,                 // fulfilled payload
  string | number,                 // arg type
  { rejectValue: string }          // rejected payload
>(
  "DELETE_CHAPTER",
  async (chapterId, { rejectWithValue }) => {
    try {
      await api.delete(`/chapters/${chapterId}/`);
      return chapterId;            // ✅ always string | number on success
    } catch (err: any) {
      return rejectWithValue(err?.response?.data ?? "Delete failed"); // ✅ no 'false'
    }
  }
);
// export const deleteChapter = createAsyncThunk(
//   DELETE_CHAPTER,
//   async (ChapterId: number | string) => {
//     try {
//       await api.delete(`${baseApiUrl}${ChapterId}/`);
//       return ChapterId;
//     } catch (err) {
//       return false;
//     }
//   }
// );

export const EDIT_CHAPTER = "EDIT_CHAPTER";
export const editChapter = createAsyncThunk(
  EDIT_CHAPTER,
  async (chapterToEdit: CHAPTER, { rejectWithValue }) => {
    try {
      const { id } = chapterToEdit;
      const { id: _omit, ...chapterData } = chapterToEdit; // strip id from payload
      const response: AxiosResponse = await api.put(
        `${baseApiUrl}${id}/`,
        chapterData            // ✅ pass the whole object as the second arg
      );
      return response.data as CHAPTER; // must include id
    } catch (err: any) {
      return rejectWithValue(err?.response?.data ?? "Update failed"); // ✅ reject, don't fulfill with null
    }
  }
);

export const GET_CHAPTER = "GET_CHAPTER";
export const getChapter = createAsyncThunk(
  GET_CHAPTER,
  async (id: string | number) => {
    const res: AxiosResponse = await api.get(`${baseApiUrl}${id}/`);
    return res.data;
  }
);

export const clearChapters = createAsyncThunk(
  "CLEAR_CHAPTERS",
  async () => null
);
